import { render, staticRenderFns } from "./UpdateRequest.vue?vue&type=template&id=039def68&"
import script from "./UpdateRequest.vue?vue&type=script&lang=js&"
export * from "./UpdateRequest.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports